export interface AppConfig {
  baseApiUrl: string;
  explorerTxBase: string;
  explorerAddressBase: string;
}

export type PartialAppConfig = Partial<AppConfig>;

export const THEME_NAMES = ['auto', 'light', 'dark', 'midnight', 'solarized', 'high-contrast'] as const;
export type ThemeName = (typeof THEME_NAMES)[number];
